/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404,
  PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidReprocessPayment.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidReprocessPayment } from "../../clients/individualPaymentOperationsController/postApiV1IndividualpaymentParcelsParcelidReprocessPayment.ts";

export const postApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationKey =
  () =>
    [
      { url: "/api/v1/individualpayment/parcels/:parcelId/reprocess-payment" },
    ] as const;

export type PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams["parcelId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId }) => {
      return postApiV1IndividualpaymentParcelsParcelidReprocessPayment(
        parcelId,
        config,
      );
    },
  });
}

/**
 * @description Dispara uma nova tentativa de cobrança no cartão de recorrência já cadastrado no plano. Exige parcela em aberto (Pendente ou Aguardando Integração), com Nosso Número, método Cartão PecegePay e token/id de recorrência no plano. Retorna 'Registered' quando a cobrança fica em aberto no gateway, 'Paid' quando é aprovada na hora (a parcela é baixada) e 'Failed' quando o cartão recusa. Migrado do legado IndividualPayment/ReprocessPayment — os ramos MundiPagg e AprovaFácil não são suportados (integrações não migradas). **(Requer Authorization para autenticação)**
 * @summary Reprocessa a cobrança de cartão recusada (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/reprocess-payment}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidReprocessPayment<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400
        | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401
        | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404
        | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams["parcelId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400
        | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401
        | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404
        | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams["parcelId"];
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams["parcelId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment400
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment401
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment404
      | PostApiV1IndividualpaymentParcelsParcelidReprocessPayment500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidReprocessPaymentPathParams["parcelId"];
    },
    TContext
  >;
}
